const trackingData = [
  {
    name: "Sat",
    km: 10,
    mt: 5,
  },
  {
    name: "Sun",
    km: 8,
    mt: 10,
  },
  {
    name: "Mon",
    km: 18,
    mt: 15,
  },
  {
    name: "Tue",
    km: 23,
    mt: 20,
  },
  {
    name: "Wed",
    km: 21,
    mt: 25,
  },
  {
    name: "Thu",
    km: 14,
    mt: 30,
  },
  {
    name: "Fri",
    km: 33,
    mt: 35,
  },
];

export default trackingData;
